export default __webpack_public_path__ + "static/media/Icon-User-Outline-Emotions-Sad.c43f998e.svg";